import React from 'react';

import { SimpleText } from '../../shared/simpleText/simpleText';

export const Resume: React.FC = () =>  {
    return (<SimpleText />);
};